import { SVGProps } from 'react';

export const PlusSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="#0C2340"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 0H7V7H0V9H7V16H9V9H16V7H9V0Z"
        />
    </svg>
);
